import { Box } from '@mui/material'
import { AccessTime } from '@mui/icons-material'
import {
  guessUserTZ,
  setTZForDateAndFormatDateOnly,
  convertUTCToTZTimeOnly,
  getCurrentDateTime,
} from '../../lib/time'
import { AlignedTypography } from '../AlignedTypography'

export const TimeStamps = (props: any) => {
  const userTZ = guessUserTZ()
  const { startTime } = props
  return <Box
    sx={{ flex: 1, alignItems: 'center', alignContent: 'flex-start', mt: 2 }}>
    <AlignedTypography variant="h6">
      Time Card {setTZForDateAndFormatDateOnly(startTime, userTZ)}
    </AlignedTypography>
    {startTime
      ? <>
        <AlignedTypography variant="h6" color='success'>
          <AccessTime sx={{ m: 2 }} />
          {setTZForDateAndFormatDateOnly(startTime, userTZ)} - {' '}
          {convertUTCToTZTimeOnly(startTime, userTZ)}
        </AlignedTypography>
      </>
      : null
    }
    <AlignedTypography variant="h6" color='primary'>
      <AccessTime sx={{ m: 2 }} />
      {convertUTCToTZTimeOnly(getCurrentDateTime(), userTZ)}
    </AlignedTypography>
  </Box>
}